/**
 * 1.3.1 portal strings, stream Q1 (quotas, email texts, logo and accent, the company activity view): what suppliers
 * see of a quota (the portal's message beside the refused upload). Q1's file; keys under quota. (and email.* only for
 * the kinds Q1 adds, none in 1.3.1).
 */
export const EXTRAS_Q1_STRINGS = {
  // The portal's text when an upload is refused at create (507 PORTAL_QUOTA, details.which); {used} and {limit} as "12.4 GB".
  'quota.month': 'Your company has used {used} of its {limit} for this month. Contact your PRISM contact to upload more.',
  'quota.pending': 'Your company has {used} waiting for review; its limit is {limit}. Uploads can go on once PRISM has reviewed some of them.',
} as const;
